/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ description, lang, meta, title, keyword }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            keywords
            image
          }
        }
      }
    `
  )

  const image = site.siteMetadata.image
  const keywords = keyword || site.siteMetadata.keywords
  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = title || site.siteMetadata?.title

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle || null}
      meta={[
        {
          name: 'viewport',
          content: 'initial-scale=1, width=device-width',
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          name: `robots`,
        },
        {
          property: `og:title`,
          content: defaultTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: image,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:image`,
          content: image,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: defaultTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "AutomotiveBusiness",
          "image": [
            "https://assets.jasaderekmobiljogja.com/bobby-towing_16.jpeg",
            "https://assets.jasaderekmobiljogja.com/bobby-towing_1.jpeg",
            "https://assets.jasaderekmobiljogja.com/bobby-towing_15.jpeg"
           ],
          "name": "Bobby Towing",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Area Sawah, Bimomartani, Kec. Ngemplak, Kabupaten Sleman",
            "addressLocality": "Daerah Istimewa Yogyakarta",
            "addressRegion": "DIY",
            "postalCode": "55584",
            "addressCountry": "ID"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": -7.7037836,
            "longitude": 110.4639443
          },
          "url": "https://jasaderekmobiljogja.com",
          "telephone": "+62818870072",
          "priceRange": "$$",
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday"
            ],
            "opens": "00:00",
            "closes": "23:59"
          }
        }
      `}</script>
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
}

export default Seo
